import { createApi, fakeBaseQuery } from '@reduxjs/toolkit/query/react';
import { RTK_TAGS } from './tags';

export const baseApi = createApi({
  reducerPath: 'api',
  baseQuery: fakeBaseQuery(),
  tagTypes: Object.values(RTK_TAGS),
  endpoints: () => ({}),
});

export * from './tags';
